import styled from "styled-components/native";

const Container = styled.ScrollView.attrs({
  scrollEnabled: true,
  showsVerticalScrollIndicator: false,
})`
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  background-color: #fff;
  max-width: 402px;
  width: 100%;
  margin: 0 auto;
`;

export default Container;